export default __webpack_public_path__ + "static/section_9_item_3-c3c003b24718f38d1d8b02b055e3698d.png";